// 26.1.8 Reflect.getPrototypeOf(target)
var $export  = require('./_export')
  , getProto = require('./_object-gpo')
  , anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target){
    return getProto(anObject(target));
  }
});


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/~/core-js/modules/es6.reflect.get-prototype-of.js
// module id = ../../../../core-js/modules/es6.reflect.get-prototype-of.js
// module chunks = 0